<template>
  <div class="flex flex-col pt-12">
    <HeaderTypo class="text-center">{{ $t('mostVisited') }}</HeaderTypo>
    <div
      class="p-4 h-[80vh] md:px-12 md:pb-12 md:pt-4 w-full grid gap-2 md:gap-3 grid-cols-3 md:grid-cols-4 lg:grid-cols-5 justify-center overflow-y-auto"
      @click="globalStore.$patch((state) => (state.topbarState = false))"
    >
      <a
        :key="key"
        :href="link.href"
        v-for="(link, key) in links"
        target="_blank"
        class="p-12 bg-neutral-700/60 aspect-square w-full h-full hover:bg-primary flex flex-col gap-y-2 justify-center items-center"
      >
        <component :is="link.icon" class=""></component>
        <span class="text-white text-sm text-center">{{ link.title }}</span>
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGlobalStore } from '@/stores/global'

import newIdCardIcon from '@/assets/svgs/most_visited/new_id_card.svg?component'
import renewIdCardIcon from '@/assets/svgs/most_visited/renew_id_card.svg?component'
import replaceIdCardIcon from '@/assets/svgs/most_visited/replace_id_card.svg?component'
import idCardStatusIcon from '@/assets/svgs/most_visited/id_card_status.svg?component'
import customerHappinessCentersIcon from '@/assets/svgs/most_visited/customer_happiness_centers.svg?component'
import complaintsIcon from '@/assets/svgs/most_visited/complaints.svg?component'
import contactDgIcon from '@/assets/svgs/most_visited/contact_dg.svg?component'
import contactUsIcon from '@/assets/svgs/most_visited/contact_us.svg?component'
import discussionWindowIcon from '@/assets/svgs/most_visited/discussion_window.svg?component'
import pollArchiveIcon from '@/assets/svgs/most_visited/poll_archive.svg?component'
import customerSatisfactionSurveyIcon from '@/assets/svgs/most_visited/customer_satisfaction_survey.svg?component'
import shareInSocialMediaIcon from '@/assets/svgs/most_visited/share_in_social_media.svg?component'
import liveChatAskHamadIcon from '@/assets/svgs/most_visited/live_chat_ask_hamad.svg?component'
import moreServicesIcon from '@/assets/svgs/most_visited/more_services.svg?component'

const globalStore = useGlobalStore()

const i18n = useI18n()

const links = computed(() => {
  return [
    {
      title: i18n.t('newIdCard'),
      href: 'https://icp.gov.ae/en/service/apply-for-a-new-id-card-2/',
      icon: newIdCardIcon
    },
    {
      title: i18n.t('renewIdCard'),
      href: 'https://icp.gov.ae/en/service/renew-id-card/',
      icon: renewIdCardIcon
    },
    {
      title: i18n.t('replaceIdCard'),
      href: 'https://icp.gov.ae/en/service/issue-a-replacement-for-lost-damaged-id-card/',
      icon: replaceIdCardIcon
    },
    {
      title: i18n.t('idCardStatus'),
      href: 'https://icp.gov.ae/en/services/priority-services/id-card-status/',
      icon: idCardStatusIcon
    },
    {
      title: i18n.t('customerHappinessCenters'),
      href: 'https://icp.gov.ae/en/customer-happiness-centers/',
      icon: customerHappinessCentersIcon
    },
    {
      title: i18n.t('complaints'),
      href: 'https://cc.icp.gov.ae/Web/landing',
      icon: complaintsIcon
    },
    {
      title: i18n.t('contactDg'),
      href: 'https://icp.gov.ae/en/engage/contact-dg',
      icon: contactDgIcon
    },
    { title: i18n.t('contactUs'), href: 'https://icp.gov.ae/en/contact-us', icon: contactUsIcon },
    {
      title: i18n.t('discussionWindow'),
      href: 'https://icp.gov.ae/en/engage/e-decision/',
      icon: discussionWindowIcon
    },
    {
      title: i18n.t('pollArchive'),
      href: 'https://icp.gov.ae/en/e-participation/poll-archive',
      icon: pollArchiveIcon
    },
    {
      title: i18n.t('customerSatisfactionSurvey'),
      href: 'https://icp.gov.ae/en/e-participation/customer-satisfaction-survey',
      icon: customerSatisfactionSurveyIcon
    },
    {
      title: i18n.t('shareInSocialMedia'),
      href: 'https://icp.gov.ae/en/e-participation/social-media',
      icon: shareInSocialMediaIcon
    },
    {
      title: i18n.t('liveChatAskHamad'),
      href: 'https://icp.gov.ae/NewsLetterv3.html',
      icon: liveChatAskHamadIcon
    },
    {
      title: i18n.t('moreServices'),
      href: 'https://icp.gov.ae/en/services',
      icon: moreServicesIcon
    }
  ]
})
</script>

<style lang="scss" scoped></style>
